<template>
  <div>
    <div class="mb-4">
      <v-row>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              Raw Material for reordering
            </v-card-title>
            <v-simple-table height="160px" style="overflow: auto;" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Stocks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in rawMaterials" :key="item.name">
                    <td class="text-left">{{ item.name }}</td>
                    <td class="text-left">{{ item.available_stocks }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              Products for reordering
            </v-card-title>
            <v-simple-table height="160px" style="overflow: auto;" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Stocks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in productTypes" :key="item.name">
                    <td class="text-left">{{ item.name }}</td>
                    <td class="text-left">{{ item.available_stocks }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              Pending Job order
            </v-card-title>
            <v-simple-table height="160px" style="overflow: auto;" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Customer Name</th>
                    <th class="text-left">Product Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in overdueCj" :key="item.name">
                    <td class="text-left">{{ item.customer.name }}</td>
                    <td class="text-left">{{ item.category }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              Receivables
            </v-card-title>
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-cash-multiple
              </v-icon>
              <v-row align="start">
                <div>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(receivables.receivables || '—').toLocaleString()"
                  ></span>
                  <strong>{{ receivables.receivables > 1 ? 'Pesos' : 'Peso' }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              Transactions
            </v-card-title>
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-counter
              </v-icon>
              <v-row align="start">
                <div>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(daily_transactions.daily_transactions || '—').toLocaleString()"
                  ></span>
                  <strong>{{
                    daily_transactions.daily_transactions > 1 ? 'Transactions' : 'Transaction'
                  }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      rawMaterials: state => state.Dashboard.rawMaterials,
      productTypes: state => state.Dashboard.productTypes,
      overdueCj: state => state.Dashboard.overdueCj,
      receivables: state => state.Dashboard.receivables,
      daily_transactions: state => state.Dashboard.daily_transactions
    })
  },
  methods: {
    ...mapActions([
      'Dashboard/fetchRawMaterials',
      'Dashboard/fetchProductTypes',
      'Dashboard/fetchOverdueCj',
      'Dashboard/fetchReceivables',
      'Dashboard/fetchDailyTransactions',
      'setDashboardRefresh'
    ]),
    refresh() {
      this['Dashboard/fetchRawMaterials']();
      this['Dashboard/fetchProductTypes']();
      this['Dashboard/fetchOverdueCj']();
      this['Dashboard/fetchReceivables']();
      this['Dashboard/fetchDailyTransactions']();
      this['setDashboardRefresh'](setTimeout(this.refresh, 30000));
    }
  },
  mounted() {
    this.refresh();
  }
};
</script>
